import React from "react";
import { Spinner } from "react-bootstrap";

const SpinnerHock = () => {
  return (
    <Spinner animation="border" variant="black" className=" m-auto h-20 w-20" />
  );
};

export default SpinnerHock;
